import React from "react";
import jQuery from "jquery";
import Relay from "react-relay/classic";
import ReactDOM from "react-dom";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import classNames from "classnames";
import Merchants from "components/pages/Merchants";
import Wallet from "components/pages/Wallet";
import Dashboard from "components/pages/Dashboard";
import Profile from "components/pages/Profile";
import Footer from "components/Footer";
import Header from "./Header";
import "./styles/index.less";
import { PH_HOST } from "config";
import PhFooter from "./PhFooter";

class App extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    router: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    relay: PropTypes.shape({
      forceFetch: PropTypes.func,
    }).isRequired,
    viewer: PropTypes.shape({
      zapperId: PropTypes.string,
      profile: PropTypes.shape({
        firstName: PropTypes.string,
        image: PropTypes.string,
      }),
    }).isRequired,
    routes: PropTypes.arrayOf(
      PropTypes.shape({
        path: PropTypes.string,
      })
    ).isRequired,
    location: PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.headerTransparentRoutes = ["/business"];
    this.state = {
      headerBodyOffset: 0,
      isHeaderTransparent: this.headerTransparentRoutes.includes(
        this.props.location.pathname
      ),
    };
    this.headerBackgroundHandler = this.headerBackgroundHandler.bind(this);
  }

  componentDidMount() {
    // Decode entities in the URL
    // Sometimes a URL like #/foo#bar will be encoded as #/foo%23bar

    window.location.hash = window.decodeURIComponent(window.location.hash);
    const scrollToAnchor = () => {
      const hashParts = window.location.hash.split("#");
      if (hashParts.length > 2) {
        const hash = hashParts.slice(-1)[0];
        document.querySelector(`#${hash}`).scrollIntoView();
      }
    };
    scrollToAnchor();
    window.onhashchange = scrollToAnchor;
    this.onScrollListenerForHeader(this.props.location.pathname);
    window.addEventListener("resize", () => {
      this.onScrollListenerForHeader(this.props.location.pathname);
    });
  }

  componentWillReceiveProps(nextProps) {
    this.onScrollListenerForHeader(nextProps.location.pathname);
  }

  onScrollListenerForHeader(pathname) {
    window.removeEventListener("scroll", this.headerBackgroundHandler, false);
    if (this.headerTransparentRoutes.includes(pathname)) {
      this.setState({
        isHeaderTransparent: true,
      });
      if (window.innerWidth <= 920) {
        window.addEventListener("scroll", this.headerBackgroundHandler, false);
      }
    } else this.setState({ isHeaderTransparent: false });
  }
  headerBackgroundHandler() {
    if (window.pageYOffset >= this.state.headerBodyOffset.top) {
      if (this.state.isHeaderTransparent) {
        this.setState({
          isHeaderTransparent: false,
        });
      }
    } else if (!this.state.isHeaderTransparent) {
      this.setState({
        isHeaderTransparent: true,
      });
    }
  }

  handleHeaderBodyOffSet(ref) {
    let element = ReactDOM.findDOMNode(ref);
    let bounding = element.getBoundingClientRect();
    this.setState({
      headerBodyOffset: {
        top: bounding.top + document.body.scrollTop,
        left: bounding.left + document.body.scrollLeft,
      },
    });
  }

  logout() {
    const { relay, router } = this.props;
    return jQuery
      .ajax({
        type: "POST",
        url: `${process.env.API_URL}/logout`,
        contentType: "application/json; charset=UTF-8",
        dataType: "json",
        crossDomain: true,
        xhrFields: { withCredentials: true },
        data: JSON.stringify({}),
      })
      .done(function () {
        relay.forceFetch({}, (readyState) => {
          if (readyState.done) router.push("/login");
        });
      })
      .fail(function () {
        console.log("logout failure");
      });
  }

  renderReactChildren() {
    return React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {
        handleHeaderBodyOffSet: (ref) => this.handleHeaderBodyOffSet(ref),
      });
    });
  }

  render() {
    let zapperId = this.props.viewer.zapperId
      ? this.props.viewer.zapperId
      : null;
    let firstName = this.props.viewer.profile
      ? this.props.viewer.profile.firstName
      : null;
    let image = this.props.viewer.profile
      ? this.props.viewer.profile.image
      : null;
    let mobileBodyWrapperClass = classNames("mobile-body-wrapper", {
      "logged-in": firstName !== null,
    });

    const { hostname } = window.location;

    const search = window.location.search; // ?header=hidden&footer=hidden
    const params = new URLSearchParams(search);
    // if no params
    const hasHeader = !(params.get('header') === 'hidden');
    const hasFooter = !(params.get('footer') === 'hidden');
    if (hasHeader && hasFooter) {
      return (
        <div id="container">
          <div id="body">
            <Header
              routes={this.props.routes}
              location={this.props.location}
              zapperId={zapperId}
              firstName={firstName}
              image={image}
              logout={() => this.logout()}
              isTransparent={this.state.isHeaderTransparent}
            />
            <div>{this.renderReactChildren()}</div>
            <div className="footer-filler" />
          </div>
          {hostname === PH_HOST ? <PhFooter /> : <Footer />}
        </div>
      );
    } else {
      return (
        <div id="container">
          <div id="body">
            <div>{this.renderReactChildren()}</div>
          </div>
        </div>
      );
    }
  }
}

export default Relay.createContainer(withRouter(App), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        zapperId,
        profile {
          firstName,
          image(size: "40x40")
        },
        ${Merchants.getFragment("viewer")},
        ${Wallet.getFragment("viewer")},
        ${Dashboard.getFragment("viewer")},
        ${Profile.getFragment("viewer")},
      }`,
  },
});



// WEBPACK FOOTER //
// ./js/components/App.js